import React, { useCallback, useEffect, useState } from 'react'
import Project from 'common/project'
import _data from 'common/utils/_data'
import { PageBanner } from 'cwp-components/PageBanner'
import { TemplateCardSmall } from './components/TemplateCardSmall'

const TopLegalDocuments = () => {
  const [legalDocs, setLegalDocs] = useState([])

  const getTopLegalDocs = useCallback(() => {
    _data
      .get(`${Project.liveApi}documents/top-legal-documents/`)
      .then((legal_docs) => {
        setLegalDocs(legal_docs)
      })
      .catch((error) => console.error(error))
  }, [])

  useEffect(() => {
    getTopLegalDocs()
  }, [getTopLegalDocs])

  return (
    <>
      <PageBanner>Top LegalDocs</PageBanner>

      <div className='flex flex-wrap justify-center gap-6 pt-10 pb-10'>
        {legalDocs.map((legalDocuments, idx) => (
          <TemplateCardSmall
            key={legalDocuments.title + idx}
            path={`/legal-documents/${legalDocuments.id}`}
            title={legalDocuments.title}
            description={legalDocuments.description}
          />
        ))}
      </div>
    </>
  )
}

export default TopLegalDocuments
